import React, { useState, useEffect, useRef } from 'react'
import { css } from 'emotion'
import { Button, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from "react-redux";
import {
  initialize
} from "state/adminData/actions";
import {
  resetOrderEdition,
  setOrderEditionInfo
} from "state/orderEdition/actions";
import {
  resetTenderCatalog
} from "state/tender/actions";
import {
  fetchGabarits,
  fetchGabarit,
  renameGabarit,
  deleteGabarit,
  setSelectedGabarit
} from "state/gabarit/actions";
import { useHistory } from 'react-router-dom';
import { faPen, faTrash, faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import swal from "sweetalert";

import FiltersContainer from 'app/orderTool/components/sidebar/filters/FiltersContainer'

const OrderSidebar = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const gabaritState = useSelector((state) => state.gabarit);
  const { list, loading, isInitialized } = gabaritState;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  // Charger les gabarits
  useEffect(() => {
    if (!isInitialized && !loading) {
      dispatch(fetchGabarits());
    }
  }, [dispatch, isInitialized, loading]);

  // Fermer le dropdown en cliquant à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const navigateToCommande = () => {
    const location = history.location;
    const queryParams = new URLSearchParams(location.search);
    queryParams.delete('order_id');
    queryParams.delete('order_type');

    history.push({
      pathname: "/commande",
      search: queryParams.toString()
    });
  };

  const handleNewDevisVierge = () => {
    dispatch(resetOrderEdition());
    dispatch(resetTenderCatalog());
    dispatch(initialize());
    dispatch(setSelectedGabarit(null));
    setIsDropdownOpen(false);
    navigateToCommande();
  };

  const handleSelectGabarit = async (gabarit) => {
    setIsDropdownOpen(false);

    try {
      // 1. Fetch le gabarit complet avec ses data (le listing ne contient pas le champ data)
      const fullGabarit = await dispatch(fetchGabarit(gabarit.id));

      // 2. Reset et initialiser
      dispatch(resetOrderEdition());
      dispatch(resetTenderCatalog());
      dispatch(initialize());

      // 3. Injecter les données du gabarit dans le store orderEdition
      setTimeout(() => {
        if (fullGabarit && fullGabarit.data) {
          dispatch(setOrderEditionInfo(fullGabarit.data));
        }
        dispatch(setSelectedGabarit(fullGabarit || gabarit));
      }, 100);

    } catch (err) {
      console.error("Erreur chargement gabarit:", err);
      // Fallback : naviguer quand même en devis vierge
      dispatch(resetOrderEdition());
      dispatch(resetTenderCatalog());
      dispatch(initialize());
    }

    navigateToCommande();
  };

  const filteredList = list.filter((g) =>
    g.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="p-2" ref={dropdownRef} style={{ position: "relative" }}>
        <Button
          variant="dark"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          block
          className={css(style.center)}
        >
          Créer un devis
        </Button>

        {isDropdownOpen && (
          <div className={css(style.dropdown)}>
            <div className={css(style.searchWrapper)}>
              <Form.Control
                type="text"
                placeholder="Recherche"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                size="sm"
                autoFocus
              />
            </div>
            <div className={css(style.listWrapper)}>
              {/* Devis vierge — toujours en premier */}
              <div
                className={css(style.gabaritItem, style.devisVierge)}
                onClick={handleNewDevisVierge}
              >
                Devis vierge
              </div>

              {loading && (
                <div className={css(style.loadingText)}>Chargement...</div>
              )}

              {!loading && filteredList.length === 0 && search && (
                <div className={css(style.loadingText)}>Aucun gabarit trouvé</div>
              )}

              {filteredList.map((gabarit) => (
                <GabaritDropdownItem
                  key={gabarit.id}
                  gabarit={gabarit}
                  onSelect={handleSelectGabarit}
                  dispatch={dispatch}
                />
              ))}
            </div>
          </div>
        )}
      </div>
      <FiltersContainer />
    </div>
  )
}

/**
 * Ligne de gabarit dans le dropdown avec icônes renommer / supprimer
 */
const GabaritDropdownItem = ({ gabarit, onSelect, dispatch }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editName, setEditName] = useState(gabarit.name);

  const handleRename = (e) => {
    e.stopPropagation();
    if (editName.trim() && editName !== gabarit.name) {
      dispatch(renameGabarit(gabarit.id, editName.trim()));
    }
    setIsEditing(false);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    swal({
      title: "Supprimer ce gabarit ?",
      text: `Le gabarit "${gabarit.name}" sera supprimé.`,
      icon: "warning",
      buttons: ["Annuler", "Supprimer"],
      dangerMode: true,
    }).then((confirm) => {
      if (confirm) {
        dispatch(deleteGabarit(gabarit.id));
      }
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleRename(e);
    if (e.key === "Escape") {
      setEditName(gabarit.name);
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <div className={css(style.gabaritItem, style.editRow)}>
        <input
          type="text"
          value={editName}
          onChange={(e) => setEditName(e.target.value)}
          onKeyDown={handleKeyDown}
          className={css(style.editInput)}
          autoFocus
          onClick={(e) => e.stopPropagation()}
        />
        <button className={css(style.iconBtn)} onClick={handleRename} title="Valider">
          <FontAwesomeIcon icon={faCheck} style={{ color: "#579862" }} />
        </button>
        <button
          className={css(style.iconBtn)}
          onClick={(e) => { e.stopPropagation(); setEditName(gabarit.name); setIsEditing(false); }}
          title="Annuler"
        >
          <FontAwesomeIcon icon={faTimes} style={{ color: "#d32f2f" }} />
        </button>
      </div>
    );
  }

  return (
    <div
      className={css(style.gabaritItem)}
      onClick={() => onSelect(gabarit)}
    >
      <span className={css(style.gabaritName)}>{gabarit.name}</span>
      <div className={css(style.gabaritActions)}>
        <button
          className={css(style.iconBtn)}
          onClick={(e) => { e.stopPropagation(); setIsEditing(true); }}
          title="Renommer"
        >
          <FontAwesomeIcon icon={faPen} size="sm" />
        </button>
        <button
          className={css(style.iconBtn)}
          onClick={handleDelete}
          title="Supprimer"
        >
          <FontAwesomeIcon icon={faTrash} size="sm" />
        </button>
      </div>
    </div>
  );
};

const style = {
  center: {
    textAlign: 'center'
  },
  dropdown: {
    position: "absolute",
    top: "100%",
    left: "8px",
    right: "8px",
    zIndex: 1050,
    backgroundColor: "#fff",
    border: "2px solid #579862",
    borderRadius: "6px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    marginTop: "2px",
    overflow: "hidden",
  },
  searchWrapper: {
    padding: "8px",
    borderBottom: "1px solid #eee",
  },
  listWrapper: {
    maxHeight: "260px",
    overflowY: "auto",
  },
  gabaritItem: {
    padding: "8px 10px",
    cursor: "pointer",
    borderBottom: "1px solid #f0f0f0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "13px",
    ":hover": {
      backgroundColor: "#f0f9f1",
    },
  },
  devisVierge: {
    fontWeight: "600",
    color: "#333",
  },
  gabaritName: {
    flex: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  gabaritActions: {
    display: "flex",
    gap: "2px",
    marginLeft: "6px",
    flexShrink: 0,
  },
  iconBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "2px 5px",
    borderRadius: "3px",
    color: "#888",
    ":hover": {
      backgroundColor: "#e8e8e8",
    },
  },
  editRow: {
    gap: "4px",
  },
  editInput: {
    flex: 1,
    border: "1px solid #579862",
    borderRadius: "4px",
    padding: "3px 6px",
    fontSize: "13px",
    outline: "none",
    minWidth: 0,
  },
  loadingText: {
    padding: "12px",
    textAlign: "center",
    color: "#999",
    fontSize: "13px",
    fontStyle: "italic",
  },
  buttonQuotation: {
    margin: '1.0rem',
    padding: '0.5rem 3rem',
    borderRadius: '0',
    fontSize: '0.8rem',
    backgroundColor: '#439b5c !important',
    border: 'none',
    textTransform: 'uppercase',
    fontWeight: 'bold'
  },
  buttonCard: {
    margin: '0.5rem 1rem',
    padding: '0.5rem 3rem',
    borderRadius: '0',
    fontSize: '0.8rem',
    backgroundColor: '#323232 !important',
    border: 'none',
    textTransform: 'uppercase',
    fontWeight: 'bold'
  },
  para: {
    color: '#c3c3c3',
    textAlign: 'center',
    fontSize: '0.8rem',
    marginBottom: '0'
  }
}

export default OrderSidebar
